import { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  useMediaQuery,
  MobileStepper,
  useTheme,
} from "@mui/material";
import Basic from "./basic";
import PersonalDetails from "./personalDetails";
import NomineeDetails from "./nomineeDetails";

const steps = ["Plan Details", "Personal Details", "Nominee Details"];

const Plans = () => {
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [basicDetails, setBasicDetails] = useState({
    startDate: "",
    noOfPersons: "",
    employeeID: "",
    emiAmount: "",
    persons: [
      {
        dob: "",
        firstName: "",
        lastName: "",
        gender: "",
        relation: "",
      },
    ],
    address1: "",
    address2: "",
    phoneNumber: "",
    email: "",
    nomineeName: "",
    nomineeRelation: "",
    nomineeDob: "",
  });

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Basic
            basicDetails={basicDetails}
            handleBasicChange={handleBasicChange}
            handleNoOfPersonsChange={handleNoOfPersonsChange}
            PersonsType={PersonsType}
          />
        );
      case 1:
        return (
          <PersonalDetails
            basicDetails={basicDetails}
            handlePersonFieldChange={handlePersonFieldChange}
          />
        );
      case 2:
        return <NomineeDetails basicDetails={basicDetails} />;
      default:
        return "Unknown step";
    }
  };

  const handleBasicChange = (field, value) => {
    if (field === "startDate") {
      const today = new Date().toISOString().split("T")[0];
      if (value < today) {
        alert("Start Date cannot be in the past");
        return;
      }
    }

    if (field === "noOfPersons") {
      const num = parseInt(value, 10);
      if (value && (isNaN(num) || num < 1 || num > 4)) {
        return;
      }
    }

    if (field === "employeeID") {
      const alphanumeric = /^[a-zA-Z0-9]*$/;
      if (!alphanumeric.test(value)) {
        return;
      }
    }

    if (field === "emiAmount") {
      const numeric = /^[0-9]*$/;
      if (!numeric.test(value)) {
        return;
      }
    }

    setBasicDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNoOfPersonsChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (isNaN(value)) value = 1;
    value = Math.max(1, Math.min(4, value)); // Clamp between 1–4

    const updatedPersons = Array.from(
      { length: value },
      (_, i) =>
        basicDetails.persons[i] || {
          dob: "",
          firstName: "",
          lastName: "",
          gender: "",
          relation: "",
        }
    );

    setBasicDetails((prev) => ({
      ...prev,
      noOfPersons: value,
      persons: updatedPersons,
    }));
  };

  const handlePersonFieldChange = (index, field, value) => {
    const updatedPersons = [...basicDetails.persons];
    updatedPersons[index][field] = value;
    setBasicDetails((prev) => ({
      ...prev,
      persons: updatedPersons,
    }));
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const PersonsType = [
    { label: "Person 1", value: "Person 1" },
    { label: "Person 2", value: "Person 2" },
    { label: "Person 3", value: "Person 3" },
    { label: "Person 4", value: "Person 4" },
  ];
  return (
    <DashboardLayout>
      <Box sx={{ width: "100%", p: 2 }}>
        {!isMobile ? (
          <>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Box>{getStepContent(activeStep)}</Box>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Button disabled={activeStep === 0} onClick={handleBack}>
                Back
              </Button>
              <Button
                onClick={handleNext}
                disabled={activeStep === steps.length - 1}
              >
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>
            </Box>
          </>
        ) : (
          <>
            <MobileStepper
              variant="dots"
              steps={steps.length}
              position="static"
              activeStep={activeStep}
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === steps.length - 1}
                >
                  Next
                </Button>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                >
                  Back
                </Button>
              }
            />
            <Box>{getStepContent(activeStep)}</Box>
          </>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default Plans;
